import { Component } from '@angular/core';

@Component({
  selector: 'app-home-layout',
  template: `
    <app-header></app-header>    
  `,
  styles: []
})
export class HomeLayoutComponent { }
